export const adaptDatabasesResponse = (response) => {
  return response?.response
    ? response?.response?.map((_database) => {
        return { ..._database, id: _database?._id };
      })
    : [];
};
